import founderImage from '../assets/images/founder.png'; // Adjust the path as needed

const FounderSection = ({hideElem}) => {
   return (
    <section className="ftco-section ftco-no-pt ftco-no-pb"> 
      <div className="container">
        {!hideElem && (
          <div className="row justify-content-center mt-3 pb-4">
            <div className="col-md-12  heading-section ftco-animate text px-4">
              <h2 className="mb-4 text-success text-center">
              S.R. Nachimuthu Gounder 
              </h2>
            </div>
          </div>
        )}

        <div className="row mt-3">
        <div className=" col-md-12 order-md-first ">
            <div className="text px-4">
              <h2 className="mb-4 text-secondary">Founder</h2>
              <p>
                 Dear Students, Parents, and Staff, <br />
                 <img src={founderImage} alt="SRN Chairman" className="img-fluid" width={400} height={200} /> 
                  The School is founded and named over by the great visionary
                  SHRI. S.R. NACHIMUTHU GOUNDER (SRN),
                  who was a well known philanthropist in the Kongu region.
                  During his life span of ninety years (15-7-1924 to 5-5-2014),
                  he has empowered the society and touched so many lives.</p>

                 <p>S.R. Nachimuthu Gounder’s dream was to create a nurturing environment where every child would receive not just academic knowledge, but the tools to grow as responsible, compassionate, and forward-thinking individuals. His belief in the transformative power of education has inspired generations of students, and his values continue to guide us as we move forward.</p>

                 <p>As we reflect on his profound impact, we are reminded of his dedication to shaping a future where students are not only successful but are also empowered to be leaders, innovators, and active global citizens. His legacy lives on in the success of each student and in the ongoing development of our institution.</p>

                 <p>We are deeply grateful for his vision and commitment, and we pledge to carry forward his dream of excellence in education.
              </p>
            
             </div>
          </div>
        </div>  
      </div>  
      <hr className="custom-hr"/>
    </section>
  );
};

export default FounderSection;
